import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from '../loginComponent/login';
import { PrivateRoute } from '../../privateRoute/privateRoute';
import Dashboard from '../dashboardComponent/dashboard';
import Register from '../registerComponent/register';
import ForgotPassword from '../forgotPassword/forgot';
import ResetPassword from '../resetPassword/reset';

class Layout extends React.Component {

    render() {
        return (
            <Switch>
                <Route path="/" component={Login} exact />
                <Route path="/register" component={Register} />
                <Route path="/forgot" component={ForgotPassword} />
                <Route path="/reset-password/:hash" component={ResetPassword} />
                <PrivateRoute path="/dashboard" component={Dashboard} />
            </Switch>
        )
    }
}
export default Layout;


// WEBPACK FOOTER //
// ./src/components/layoutComponent/layout.js